import script from "./HomeWagePremiumAdjustModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeWagePremiumAdjustModal.vue?vue&type=script&setup=true&lang=ts"

import "./HomeWagePremiumAdjustModal.vue?vue&type=style&index=0&id=ce00a2d4&lang=scss"

const __exports__ = script;

export default __exports__